import { SET_PAYMENT_METHODS, SET_PUB_KEY, SET_SEPA_DATA } from './constants';

export const setPaymentMethods = payload => ({ type: SET_PAYMENT_METHODS, payload });
export const setPubKey = payload => ({ type: SET_PUB_KEY, payload });
export const setSepaData = payload => ({ type: SET_SEPA_DATA, payload });
